module.exports = __webpack_public_path__ + "img/rexian.9cda5187.png";